import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { GeneralAutocompleteComponent } from '../../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { TemplateService } from '../../../../../../core/lists/_services/template.service';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { RelatedTemplatesService } from '../../../../../../core/services/related-templates.service';

@Component({
  selector: 'kt-related-templates',
  templateUrl: './related-templates.component.html',
  styleUrls: ['./related-templates.component.scss'],
})
export class RelatedTemplatesComponent implements OnInit {
  form: FormGroup;
  activityForm: FormGroup;
  relatedTemplates = [];
  relatedActivityTemplates = [];
  templateAutocompleteCall;
  activityTemplateAutocompleteCall;
  @ViewChild('templateAutocomplete') templateAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('activityTemplateAutocomplete')
  activityTemplateAutocomplete: GeneralAutocompleteComponent;
  _templateId: number;
  @Input() set templateId(value: number) {
    if (!value) {
      this.relatedTemplates = [];
      this.relatedActivityTemplates = [];
      return;
    }
    this._templateId = value;
    this.templateAutocompleteCall = this.relatedTemplateService.searchTemplates.bind(
      this.relatedTemplateService,
      this._templateId,
    );

    this.activityTemplateAutocompleteCall =
      this.relatedTemplateService.searchActivityTemplates.bind(this.relatedTemplateService);

    this.loadTemplates(this._templateId);
    this.loadActivityTemplates(this._templateId);
  }
  @Input() mode;

  constructor(
    private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private relatedTemplateService: RelatedTemplatesService,
    private templateService: TemplateService,
    private layoutUtilsService: LayoutUtilsService,
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      task_template: [null, Validators.required],
    });
    this.activityForm = this.formBuilder.group({
      activity_template: [null],
    });
    // View Mode
    if (this.mode === 'view') {
      this.form.disable();
      this.activityForm.disable();
    }
  }

  reset(): void {
    this.form.reset();
    this.activityForm.reset();
    this.templateAutocomplete?.setValue(null);
    this.templateAutocomplete.setErrors(null);
    this.activityTemplateAutocomplete?.setValue(null);
    this.activityTemplateAutocomplete.setErrors(null);
  }

  addTemplate(event: Event): void {
    event.stopPropagation();
    const controls = this.form.controls;
    this.templateAutocomplete.updateValueAndValidity();
    if (this.form.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    const formValue = this.form.value;
    if (!formValue.task_template) {
      return;
    }
    this.relatedTemplateService
      .addRelatedTemplate(this._templateId, formValue.task_template?.id)
      .subscribe(() => {
        this.loadTemplates(this._templateId);
        this.layoutUtilsService.showActionNotification(
          'Related template added successfully',
          MessageType.Create,
          3000,
          false,
          false,
        );
      });
    this.reset();
  }

  addActivityTemplate(event: Event): void {
    event.stopPropagation();
    this.activityTemplateAutocomplete.updateValueAndValidity();
    const formValue = this.activityForm.value;
    if (!formValue.activity_template) {
      return;
    }
    this.relatedTemplateService
      .addRelatedActivityTemplate(this._templateId, formValue.activity_template?.id)
      .subscribe(() => {
        this.loadActivityTemplates(this._templateId);
        this.layoutUtilsService.showActionNotification(
          'Related activity template added successfully',
          MessageType.Create,
          3000,
          false,
          false,
        );
      });
    this.reset();
  }

  deleteTaskTemplate(event: Event, template): void {
    event.stopPropagation();
    const _title = 'Delete Related Template';
    const _description = 'Are you sure you want to delete this template?';
    const dialogRef = this.layoutUtilsService.confirmAction(_title, _description, 'Loading...');
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.relatedTemplateService
        .deleteRelatedTemplate(this._templateId, template.id)
        .subscribe(() => {
          this.loadTemplates(this._templateId);
          this.layoutUtilsService.showActionNotification(
            'Related template deleted successfully',
            MessageType.Delete,
            3000,
            false,
            false,
          );
        });
    });
  }

  deleteActivityTemplate(event: Event, template): void {
    event.stopPropagation();
    const _title = 'Delete Related Activity Template';
    const _description = 'Are you sure you want to delete this template?';
    const dialogRef = this.layoutUtilsService.confirmAction(_title, _description, 'Loading...');
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.relatedTemplateService
        .deleteRelatedActivityTemplate(this._templateId, template.id)
        .subscribe(() => {
          this.loadActivityTemplates(this._templateId);
          this.layoutUtilsService.showActionNotification(
            'Related template deleted successfully',
            MessageType.Delete,
            3000,
            false,
            false,
          );
        });
    });
  }

  filterTemplateFn(template: any): string {
    return template ? template.name : '';
  }
  filterActivityTemplateFn(template: any): string {
    return template ? template.name : '';
  }

  onTemplateChange(val) {
    this.form.get('task_template').setValue(val);
    this.form.get('task_template').updateValueAndValidity();
  }

  onActivityTemplateChange(val) {
    this.activityForm.get('activity_template').setValue(val);
    this.activityForm.get('activity_template').updateValueAndValidity();
  }

  loadTemplates(templateID) {
    this.relatedTemplateService.getRelatedTemplates(templateID).subscribe((templates) => {
      this.relatedTemplates = templates?.data?.task_templates || [];
      this.cdr.detectChanges();
    });
  }
  loadActivityTemplates(templateID) {
    this.relatedTemplateService.getRelatedActivityTemplates(templateID).subscribe((templates) => {
      this.relatedActivityTemplates = templates?.data || [];
      this.cdr.detectChanges();
    });
  }
}
